/**
 * Extract invitation token from URL parameters
 * Looks for 'invitation_token' or 'token' parameter in URL
 */
export function getInvitationTokenFromUrl(): string | null {
  try {
    const urlParams = new URLSearchParams(window.location.search);

    // Check for both possible parameter names
    const invitationToken =
      urlParams.get("invitation_token") || urlParams.get("invitation");

    if (invitationToken) {
      // // Remove the token from URL to clean up the address bar
      // urlParams.delete("invitation_token");
      // urlParams.delete("invitation");

      // const newUrl = `${window.location.pathname}${
      //   urlParams.toString() ? `?${urlParams.toString()}` : ""
      // }`;
      // window.history.replaceState({}, "", newUrl);

      return invitationToken;
    }

    return null;
  } catch (error) {
    console.error("Error extracting invitation token from URL:", error);
    return null;
  }
}

/**
 * Store invitation token temporarily in sessionStorage for use during auth flow
 */
export function storeInvitationToken(token: string): void {
  try {
    sessionStorage.setItem("pending_invitation_token", token);
  } catch (error) {
    console.error("Error storing invitation token:", error);
  }
}

/**
 * Retrieve and remove stored invitation token
 */
export function retrieveAndClearInvitationToken(): string | null {
  try {
    const token = sessionStorage.getItem("pending_invitation_token");
    if (token) {
      sessionStorage.removeItem("pending_invitation_token");
    }
    return token;
  } catch (error) {
    console.error("Error retrieving invitation token:", error);
    return null;
  }
}
